import { LightShowOperation } from './lightshow-operation';
import { LightshowState } from '../lightshow-state';
import { FlashTypes } from '../operation-types';

export class ImageFadeinnOperation extends LightShowOperation {

  public imageUrl: string;

  constructor(position: number, duration: number, imageUrl: string) {
    super();
    this.position = position;
    this.duration = duration;
    this.imageUrl = imageUrl;
  }

  public toJson(allOperations: LightShowOperation[]): any[] {
    const index = allOperations.filter(o => o.flashType === this.flashType).indexOf(this);
    return [
      { type: FlashTypes.imagePrefetch, duration: 0.25, time: 50 + index * 100, url: this.imageUrl }, // preload image
      { type: FlashTypes.imageFetchAndShow, duration: Math.round(this.duration) / 1000, time: Math.round(this.position), url: this.imageUrl }, // show image
    ];
  }

  public end(state: LightshowState) {
    state.imageUrl = this.imageUrl;
    state.imageOpacity = 1;
  }
  public tick(state: LightshowState) {
    state.imageUrl = this.imageUrl;
    state.imageOpacity = (state.playbackPosition - this.position) / this.duration;
  }
  public wait(state: LightshowState) {
    // it's possible that the url is a safe reference to the in-memory blob (sanitized temp url) in which case it's already loaded
    if (this.imageUrl && this.imageUrl.constructor.name.toLowerCase() === 'string') {
      state.preloadImage(this.imageUrl);
    }
  }
}
